import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505] text-slate-300">
      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16">
        <Link to="/" data-testid="privacy-back" className="inline-flex items-center gap-2 text-sm text-teal-light hover:text-white transition-colors">
          <ArrowLeft size={16} /> Torna alla home
        </Link>
        <h1 className="mt-8 font-display text-4xl text-white">Privacy Policy</h1>
        <p className="mt-2 text-sm text-slate-500">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-white">1. Titolare del trattamento</h2>
            <p className="mt-2">Fast Life Studio Agency. Contatti: {CONTACT.email} — {CONTACT.phoneDisplay}.</p>
          </section>
          <section>
            <h2 className="font-display text-xl text-white">2. Dati raccolti</h2>
            <p className="mt-2">Attraverso il modulo di contatto raccogliamo: nome e cognome, nome dell'attività, settore, città, numero di telefono, e-mail, profilo Instagram, piano di interesse e obiettivi. Questi dati sono utilizzati esclusivamente per rispondere alle richieste di consulenza.</p>
          </section>
          <section>
            <h2 className="font-display text-xl text-white">3. Cookie</h2>
            <p className="mt-2">Il sito utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie di analisi e marketing (es. Google Analytics, Meta Pixel). Puoi gestire il consenso tramite il banner dedicato.</p>
          </section>
          <section>
            <h2 className="font-display text-xl text-white">4. Base giuridica e conservazione</h2>
            <p className="mt-2">Il trattamento avviene sulla base del consenso e per l'esecuzione di misure precontrattuali. I dati vengono conservati per il tempo necessario a gestire la richiesta e adempiere agli obblighi di legge.</p>
          </section>
          <section>
            <h2 className="font-display text-xl text-white">5. Diritti dell'interessato</h2>
            <p className="mt-2">Hai diritto di accedere, rettificare, cancellare i tuoi dati e opporti al trattamento scrivendo a {CONTACT.email}.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
